module.exports = __webpack_public_path__ + "img/5-3pay.b3b11bed.png";